"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareSuggestionsModified = exports.compareSuggestionsSubmitted = exports.useSuggestionsForOpening = void 0;
const react_1 = require("react");
const useProjectState_1 = require("../../../useProjectState");
function useSuggestion(suggestionId) {
    const file = (0, useProjectState_1.useProjectFile)();
    const suggestion = (0, react_1.useMemo)(() => file.openingSuggestions.find(suggestion => suggestion.id === suggestionId), [file.openingSuggestions]);
    return suggestion;
}
exports.default = useSuggestion;
function useSuggestionsForOpening(openingId) {
    const file = (0, useProjectState_1.useProjectFile)();
    const suggestion = (0, react_1.useMemo)(() => file.openingSuggestions
        .filter(suggestion => suggestion.openingId === openingId)
        .sort(compareSuggestionsSubmitted), [file.openingSuggestions]);
    return suggestion;
}
exports.useSuggestionsForOpening = useSuggestionsForOpening;
const StatusSort = {
    DRAFT: 1,
    SUBMITTED: 1,
    HIDDEN: 3,
};
function compareSuggestionsSubmitted(a, b) {
    var _a, _b;
    const aStatus = StatusSort[a.status];
    const bStatus = StatusSort[b.status];
    if (aStatus != bStatus) {
        return aStatus - bStatus;
    }
    const aDate = (_a = a.submittedAt) !== null && _a !== void 0 ? _a : a.input.modifiedAt;
    const bDate = (_b = b.submittedAt) !== null && _b !== void 0 ? _b : b.input.modifiedAt;
    if (aDate < bDate) {
        return 1;
    }
    else if (aDate > bDate) {
        return -1;
    }
    return 0;
}
exports.compareSuggestionsSubmitted = compareSuggestionsSubmitted;
function compareSuggestionsModified(a, b) {
    const aStatus = StatusSort[a.status];
    const bStatus = StatusSort[b.status];
    if (aStatus != bStatus) {
        return aStatus - bStatus;
    }
    const aDate = a.input.modifiedAt;
    const bDate = b.input.modifiedAt;
    if (aDate < bDate) {
        return 1;
    }
    else if (aDate > bDate) {
        return -1;
    }
    return 0;
}
exports.compareSuggestionsModified = compareSuggestionsModified;
//# sourceMappingURL=data:application/json;base64,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